export default `
  <tj-wrapper lang="fr"></tj-wrapper>
`;
